import Vue from 'vue';
import MobileDetect from 'mobile-detect';
import browserDetect from '@/helpers/browser';
import * as types from '../mutation-types';

const device = () => {
  const detector = new MobileDetect(window.navigator.userAgent);
  return detector;
};

// initial state
const state = {
  globals: {},
  popup: false,
  careerSlide: 0,
  popupAnimation: false,
  globalVisibility: false,
  browser: browserDetect(),
  mobile: device().mobile(),
};

// getters
const getters = {
  globals: stateFreezed => stateFreezed.globals,
  globalVisibility: stateFreezed => stateFreezed.globalVisibility,
  popupAnimation: stateFreezed => stateFreezed.popupAnimation,
  careerSlide: stateFreezed => stateFreezed.careerSlide,
  browser: stateFreezed => stateFreezed.browser,
  mobile: stateFreezed => stateFreezed.mobile,
  popup: stateFreezed => stateFreezed.popup,
};

// actions
const actions = {
  fetchGlobal({ commit }) {
    Vue.http.get('global/')
    .then((response) => {
      // get body data
      commit(types.RECEIVE_GLOBAL, response.body.content);
    });
  },
  popupState({ commit }, status) {
    if (status) {
      commit(types.POPUP_STATE, status);
      setTimeout(() => {
        commit(types.POPUP_ANIMATION, status);
      }, 100);
    } else {
      commit(types.POPUP_ANIMATION, status);
      setTimeout(() => {
        commit(types.POPUP_STATE, status);
      }, 300);
    }
  },
};

// mutations
const mutations = {
  [types.RECEIVE_GLOBAL](stateFreezed, globFetched) {
    const st = stateFreezed;
    st.globals = globFetched;
  },
  [types.POPUP_STATE](stateFreezed, status) {
    const st = stateFreezed;
    st.popup = status;
  },
  [types.POPUP_ANIMATION](stateFreezed, status) {
    const st = stateFreezed;
    st.popupAnimation = status;
  },
  [types.CAREER_SLIDE](stateFreezed, status) {
    const st = stateFreezed;
    st.careerSlide = status;
  },
  [types.ENABLE_ALL_VISIBILITY](stateFreezed, status) {
    const st = stateFreezed;
    st.globalVisibility = status;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/global.js